module.exports = __webpack_public_path__ + "assets/img/5_1193_big.ff63e788.jpg";